import PageIntro from "@/components/PageIntro";
import Download from "@/components/sections/Download";
import Roadmap from "@/components/sections/Roadmap";

export default function DownloadPage() {
  return (
    <div data-testid="download-page">
      <PageIntro
        eyebrow="Download"
        title="FestivalPlan ist da!"
        lead="Seit Oktober 2026 offiziell für Android und iOS verfügbar – im Google Play Store und im Apple App Store. Kostenlos herunterladen und loslegen."
      />
      <Download compact />
      <Roadmap />
    </div>
  );
}
